/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-images.vue?vue&type=template&id=457a3284&scoped=true"
import script from "./pc-images.vue?vue&type=script&lang=js"
export * from "./pc-images.vue?vue&type=script&lang=js"
import style0 from "./pc-images.vue?vue&type=style&index=0&id=457a3284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a3284",
  null
  
)

export default component.exports